module.exports = __webpack_public_path__ + "static/media/icon_business.e86dc8dd.svg";